import axios from 'axios';
import get from 'lodash/get';
import concat from 'lodash/concat';
import isEmpty from 'lodash/isEmpty';
import { getUrl } from '@/config/api.routes';
import { useTimeZone, unixStampToTzAttachedMoment } from '@/libs';
import dayjs from '@/localPlugins/dayjs';

export default {
  namespaced: true,

  state: {
    survey: {
      // TODO: Currently there is no way switch survey between nps and csat
      surveyType: 'csat',
      feedbackItems: [],
    },
    onboarding: {
      items: [],
    },
  },

  getters: {},

  mutations: {
    SELECT_METRIC(state, item) {
      state.selected = item;
    },

    SET_FEEDBACK(state, feedbackItems = []) {
      state.survey.feedbackItems = feedbackItems;
    },

    EXTEND_FEEDBACK(state, feedbackItems = []) {
      state.survey.feedbackItems = concat(get(state, 'survey.feedbackItems', []),
        feedbackItems);
    },

    SET_SURVEY_TYPE(state, surveyType) {
      state.survey.surveyType = surveyType;
    },

    SET_ONBOARDING(state, items = []) {
      state.onboarding.items = items;
    },

    EXTEND_ONBOARDING(state, items = []) {
      state.onboarding.items = concat(get(state, 'onboarding.items', []), items);
    },
  },

  actions: {
    async getMetric(context, [metric, config]) {
      const timezone = await useTimeZone(
        Intl.DateTimeFormat().resolvedOptions().timeZone,
        this.dispatch,
        context.rootState.configs);
      const payload = { ...config, time_zone: timezone };
      //apply timezone to unix start and end time
      payload.period_start = unixStampToTzAttachedMoment(payload.period_start,
        timezone).unix();
      payload.period_end = unixStampToTzAttachedMoment(payload.period_end,
        timezone).unix();
      return axios.post(getUrl('metrics', metric), payload)
        .then(data => {
          const metricData = data.data || {};
          return metricData;
        });
    },
    getTeams() {
      return axios.post(getUrl('teamsList'))
        .then(data => data || {});
    },
    async getChannels() {
      const res = await axios.get(`${getUrl('conversations.conversations')}/channelslist`);
      return res || {};
    },

    async getPlatformCommsList({_commit}, [metric, config]) {
      return await axios.post(getUrl('metrics', metric), config)
        .then(data => {
          return data.data;
        });

    },
    getFeedbackType({ commit, dispatch }) {
      return dispatch('configs/getPostChatSurvey', null, { root: true })
        .then(data => {
          const surveyType = get(data, 'survey_type', 'csat');
          commit('SET_SURVEY_TYPE', surveyType);
          return surveyType;
        });
    },
    async getFeedbackList({ commit, state }, { params, extend_state }) {
      params = Object.assign({}, params, { survey_type: state.survey.surveyType });
      const data = await axios.get(getUrl('metrics', 'customer_feedback'), { params });
      if (extend_state) {
        commit('EXTEND_FEEDBACK', data.data.models);
      } else {
        commit('SET_FEEDBACK', data.data.models);
      }
      return data.data;
    },
    async getOnboardingList({ commit }, { params, extend_state }) {
      const timezone = await useTimeZone(
        Intl.DateTimeFormat().resolvedOptions().timeZone,
        this.dispatch,
        this.state.configs);
      const payload = { ...params, time_zone: timezone };
      payload.period_start = unixStampToTzAttachedMoment(payload.period_start,
        timezone).unix();
      payload.period_end = unixStampToTzAttachedMoment(payload.period_end,
        timezone).unix();
      const data = await axios.post(getUrl('metrics', 'per_customer_onboarding_progress'), payload);
      const items = get(data, 'data.dataset.0.data_points', []);
      if (extend_state) {
        commit('EXTEND_ONBOARDING', items);
      } else {
        commit('SET_ONBOARDING', items);
      }
      return data.data;
    },
    async getSummary(_, { metricsName, metricsRange, summaryData }) {
      const payload = {
        data: JSON.stringify(summaryData),
      };

      if (!isEmpty(metricsRange) && metricsRange.length === 2) { // eslint-disable-line no-magic-numbers
        payload.range = {
          start: dayjs(metricsRange[0] * 1000), // eslint-disable-line no-magic-numbers
          end: dayjs(metricsRange[1] * 1000), // eslint-disable-line no-magic-numbers
        };
      }
      return (await axios.post(`${getUrl('metrics', metricsName)}/summary`, payload)).data.summary;
    },
  },
};
